import type {AlgorithmId,LevelDefinition} from '@algoquest/schemas';
import {campaignPlan,strategyChoices} from '@algoquest/shared/campaign/challenge';
import {createSortController} from '../algorithms/sorting/createSortController';
import {createSearchController} from '../algorithms/searching/createSearchController';
/** Exact reference runs of the same controllers and dataset, without player movement/time. */
export function compareStrategies(base:LevelDefinition){
 return strategyChoices(base).map(algorithm=>{
  let comparisons=0,swaps=0,shifts=0;
  for(const level of campaignPlan(base,algorithm)){
   const d=level.dataset;
   if(d.kind==='searching'){
    const c=createSearchController(level.algorithm as 'linear-search'|'binary-search',d.values,d.target);let steps=0;
    while(!c.getView().isComplete&&steps++<1000){const v=c.getView();if(v.awaitingChoice)c.handleDirectionChoice(d.target<d.values[v.focusIndex!]!?'left':'right');else c.handlePrimaryAction(v.focusIndex);}
    if(!c.getView().isComplete)throw Error('Search reference did not finish');comparisons+=c.getView().comparisons;
   }else{
    const c=createSortController(level.algorithm as Exclude<AlgorithmId,'linear-search'|'binary-search'>,d.values,d.sortDirection);let steps=0;
    while(!c.getView().isComplete&&steps++<10000){const v=c.getView(),[a,b]=v.compareIndices.map(i=>v.values[i]!);if(v.awaitingDecision)c.handleDecision((d.sortDirection==='ascending'?a!>b!:a!<b!)?'advance':'resolve');else c.handlePrimaryAction(v.requiredIndex);}
    const v=c.getView();if(!v.isComplete)throw Error('Sort reference did not finish');comparisons+=v.comparisons;swaps+=v.swaps;shifts+=v.shifts;
   }
  }
  return {algorithm,comparisons,swaps,shifts,operations:comparisons+swaps+shifts};
 });
}
